export default __webpack_public_path__ + "static/media/EAST2460.34I-34266_-18493_0.c69e9dc1.jpg";